import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeOne from '../views/HomeOne'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'homeOne',
    component: HomeOne
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
    //第一页
  {
    path: '/homeOne',
    name:'homeOne',
    component: () => import('../views/HomeOne')
  },
  {
    path: '/homeTwo',
    name:'homeTwo',
    component: () => import('../views/HomeTwo')
  },
    //第三页
  {
    path: '/homeThird',
    name:'homeThird',
    component: () => import('../views/HomeThird')
  },
    //联系我们
  {
    path: '/homeFour',
    name: 'homeFour',
    component: () => import('../views/HomeFour.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
